var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStatsSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6442 30.0023C22.4228 30.0023 28.0161 24.9269 28.8506 18.3638C28.9655 17.4578 28.261 16.6578 27.3509 16.6578H17.9118C16.6601 16.6578 15.6443 15.6397 15.6443 14.3853V4.9254C15.6443 4.01335 14.8461 3.30734 13.9421 3.42249C7.39326 4.26182 2.33203 9.86745 2.33203 16.6579C2.33203 24.0422 8.27913 30.0023 15.6442 30.0023Z",
    fill: "#674df6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8025 2.01224C17.9015 1.8971 17.1094 2.60917 17.1094 3.51516V13.7325C17.1094 14.5688 17.7866 15.2476 18.6211 15.2476H28.8191C29.7261 15.2476 30.4336 14.4537 30.3187 13.5507C29.5568 7.53909 24.804 2.77582 18.8025 2.01224Z",
    fill: "#674df6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatsSection);
export default __webpack_public_path__ + "static/media/icon-stats-section.4401ed24.svg";
export { ForwardRef as ReactComponent };